import VacancyList from "../components/VacancyList";

const ListVacancyPage = () => {
  return (
    <VacancyList />
  );
};

export default ListVacancyPage;
